import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const PaymentSuccess = () => {
  const history = useHistory();
  const [count, setCount] = useState(10);

  useEffect(() => {
    const t = setInterval(() => setCount(p => {
      if (p <= 1) { clearInterval(t); history.push("/login"); return 0; }
      return p - 1;
    }), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg,#080E1C,#0F1B35)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter',system-ui,sans-serif", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "48px 40px", maxWidth: 480, width: "100%", textAlign: "center", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ width: 72, height: 72, borderRadius: "50%", background: "rgba(34,197,94,0.1)", border: "2px solid rgba(34,197,94,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2rem", margin: "0 auto 20px" }}>✅</div>
        <h1 style={{ fontWeight: 800, fontSize: "1.5rem", color: "#0F172A", marginBottom: 10, letterSpacing: "-0.5px" }}>Pagamento aprovado!</h1>
        <p style={{ color: "#64748B", fontSize: "0.95rem", lineHeight: 1.7, marginBottom: 24 }}>
          Sua conta Korax está sendo preparada.<br />
          Enviamos no seu e-mail o link para criar sua senha e acessar a plataforma.
        </p>
        <div style={{ background: "#F8FAFC", border: "1px solid #E8EDF5", borderRadius: 12, padding: "14px 20px", marginBottom: 24, fontSize: "0.85rem", color: "#64748B" }}>
          📧 Verifique sua caixa de entrada — pode levar alguns minutos.
        </div>
        <div style={{ fontSize: "0.8rem", color: "#94A3B8" }}>Redirecionando para o login em {count}s...</div>
        <button onClick={() => history.push("/login")} style={{ marginTop: 16, background: "#1D4ED8", color: "#fff", border: "none", borderRadius: 10, padding: "12px 28px", fontWeight: 700, fontSize: "0.9rem", cursor: "pointer" }}>
          Ir para o login →
        </button>
      </div>
    </div>
  );
};
export default PaymentSuccess;
